const menuDisplay = () => import(/* webpackChunkName: "dinein setting" */ '@/components/settings/menuDisplay')

export default {
    name: 'menuDisplay',
    path: 'Visuals/menuDisplay',
    redirect: '/Visuals/menuDisplay/index',
    meta: {label: 'Visuals'},
    component: {
        render (c) { return c('router-view') }
    },
    children: [
        {
            path: 'index',
            meta: {label: 'Index', auth: [0, 1, 2, 3, 4, 5, 6, 7]},
            component: menuDisplay,
            props: true
        }
    ]
}
